import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from 'antd';

import CheckIcon from '@/assets/icons/check-mark.svg?react';

const CheckVerify: React.FC<{}> = () => {
  const [t] = useTranslation();
  const history = useNavigate();

  return (
    <div className="auth-form auth-form--check-verify">
      <CheckIcon className="auth-form__check-icon" />
      <div className="auth-form__title">
        {t('checkMail')}!
        <br />
        {t('thereIsLink')}
      </div>

      <Button className="auth-form__button" type="primary" onClick={() => history('/login')}>
        {t('backToLogin')}
      </Button>
    </div>
  );
};

export default CheckVerify;
